import React from "react";
import { useTranslation } from "react-i18next";
import {TagName} from "../../../model/Tags"
import { useModifiedBy } from "../ResizeStyles/WorkSpaceItemListStyles/ModifiedBy";
import Btn, { TypeStyle } from "../../../components/Button/Btn";
import { tags } from "../WorkSpaceItemListStyle/ColumnStandard";
import { EnumPermissionTypeNone } from "../../../enums/EnumPermissionTypeNone";
import EmptyTag from "./Components/TagField/EmptyTag";
import { Badge, Box, Typography } from "@mui/material";
import { AddCircle } from "@mui/icons-material";

interface TagsFieldProps {
    itemType:string;
    boxLayout:boolean;
    onClickTag:() => void;
    tagInternal:TagName[] | undefined;
    permissionType?: number;
}

const TagsField: React.ForwardRefExoticComponent<TagsFieldProps> =
	React.forwardRef(({itemType,boxLayout,onClickTag, tagInternal, permissionType }, ref: React.Ref<HTMLLIElement>) => {

    const { t, i18n } = useTranslation();
    
    const firstTagName: string|undefined = tagInternal == undefined ? undefined : tagInternal.length == 0 ? undefined : tagInternal[0].name;
    const tagLength: number =tagInternal == undefined ? 0 : tagInternal.length - 1;

    const modifiedBy = useModifiedBy();

    return (
        <div  className={`${boxLayout?modifiedBy.myDiv:modifiedBy.default}`}
          style={{
            gridArea:tags,
            width: "138px",
          }}
        >
             {itemType != "folder" ? (
                 tagInternal != undefined ? (
                  tagInternal.length > 0 ?(
                    tagLength > 0 ? (
                    <Badge badgeContent={`+ ${tagLength}`}  sx={{"& .MuiBadge-badge": {backgroundColor:'#22638D', color: "#FFF",     transform: "scale(1) translate(50%, 15%)"}}}>
                      <Btn
                            text={firstTagName}
                            style={TypeStyle.EditTagButton}
                            onClick={onClickTag}
                        />
                      </Badge>) : (
                        <Btn
                            text={firstTagName}
                            style={TypeStyle.EditTagButton}
                            onClick={onClickTag}
                        />)
                  ):((permissionType == EnumPermissionTypeNone.edit || permissionType == EnumPermissionTypeNone.organize) ? 
                    <div style={{ display: "flex" }}>
                      <Btn
                        text={
                          <Box sx={{display:'flex', gap: '5px', alignItems: 'center'}}>
                            <AddCircle sx={{ color: '#22638D', fontSize: '14px' }} /> 
                            {t("tag.add")}
                          </Box>
                        }
                        style={TypeStyle.AddTagButton}
                        onClick={onClickTag}
                      />
                    </div> : <EmptyTag/>
                    )            
                ):( (permissionType == EnumPermissionTypeNone.edit || permissionType == EnumPermissionTypeNone.organize) ?
                  <div style={{display:"flex"}}> 
                      <Btn
                        text={
                          <Box sx={{display:'flex', gap: '5px', alignItems: 'center'}}>
                            <AddCircle sx={{ color: '#22638D', fontSize: '14px' }} /> 
                            {t("tag.add")}
                          </Box>
                        }
                        style={TypeStyle.AddTagButton}
                        onClick={onClickTag}
                      />       
                  </div> : <EmptyTag/>
                )              
              ) : 
              <EmptyTag/>
              }
        </div>        
    );
});

    
export default TagsField;
